<div class="main" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center stretch">
  <div class="img-fondo" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center stretch">
      <span  class="text-title-fondo" fxFlex="100" fxLayoutAlign="center stretch">¡UPS!</span>
      <span  class="text-subtitle-fondo" fxFlex="100" fxLayoutAlign="center stretch">{{ 'LandingPolimentes.notfound.sentimos' | translate }} </span>
      <button class="btn-fondo" fxFlex="100" fxLayoutAlign="center stretch" [routerLink]="'/'">{{ 'LandingPolimentes.notfound.inicio' | translate }}</button>
  </div>

</div>
